// DO NOT EDIT -- generated from fs/api/segment/journeymap.proto

import { DependentEventFilter, Event } from './event.proto';
import { EventSequence } from './event_sequence.proto';
import { TimeRange } from './values.proto';
import * as protobuf from '../../../google/protobuf';

export interface Journey {
  definition?: JourneyMap | null;
  /**
   * List of match rules that must be satisfied for the journey map behavior.
   * These matches are ordered (with the entry at pivot_index signifying the pivot index).
   * There must be enough matches to satisfy the pivot index.
   */
  matches: Journey.Match[];
  /** The match rule index that corresponds to the pivot. Must be in range [0, matches.length). */
  pivotIndex: number;
  /** If true, requires that the journey entry point is into the first match clause. */
  enters: boolean;
  /** If true, requires that the journey exit point is out of the last match clause. */
  exits: boolean;
  /** Dependent filters applied to each event in the journey (pivot and interactions). */
  deps: DependentEventFilter[];
}

export namespace Journey {
  export enum journey_map {
    definition = 1
  }

  export function journey_map_oneof(m: Journey): { opt: journey_map.definition, val: JourneyMap } | null {
    if (m.definition != null) { return { opt: journey_map.definition, val: m.definition } }
    return null;
  }

  export interface Match {
    any?: boolean;
    identValues?: EventIdentValues | null;
  }

  export namespace Match {
    export enum match {
      any = 1,
      identValues = 2
    }

    export function match_oneof(m: Match): { opt: match.any, val: boolean } | { opt: match.identValues, val: EventIdentValues } | null {
      if (m.any != null) { return { opt: match.any, val: m.any } }
      if (m.identValues != null) { return { opt: match.identValues, val: m.identValues } }
      return null;
    }
  }
}

export interface JourneyMap {
  /**
   * The event definitions (ORed together) that should be used to match pivot events.
   * The first matching pivot for each group (indv or session, based on constraints.in_same_session) will be the basis
   * for each computed journey.
   * Either this field or pivot_sequence must be set.
   */
  pivot: Event[];
  /**
   * The event sequence that should be matched for the purposes of the pivot.
   * Currently, when pivot sequences are used, the pivot sequence must be the entry events.
   * Either this field or pivot must be set.
   */
  pivotSequence: EventSequence | null;
  /**
   * If true, matched journeys will pivot on the last matching pivot for each group (indv or session, based on constraints.in_same_session).
   * By default, if this flag is unset or false, the standard behavior of pivoting on the first matching pivot remains.
   * This flag is especially useful for "ends with" style journeys to provide more room to look backwards in the
   * case that the pivot can occur multiple times within a group.
   */
  latestPivot: boolean;
  /**
   * The event definitions (ORed together) that should be used to match interaction events.
   * The nearest B backwards and F forward events to the pivot for each scope will be matched for each computed journey.
   */
  interactions: Event[];
  /**
   * The identity configuration for specific event types matched in the journey map.
   * All events are identified at least by their type. Optional further identity is configured here.
   */
  eventIdent: EventIdent | null;
  /**
   * The constraints for the journey.
   * The in_same_session value determines whether journeys are computed per individual or per session.
   * Time range will be applied to the pivot and interactions.
   */
  constraints: JourneyMapConstraints | null;
  /**
   * Whether or not to collapse repeated values.
   * If true, collapsing of repeated values (by identity, no interactions in between) will occur.
   * Note: Collapsing is best effort and in rare cases may collapse too aggressively.
   */
  collapseRepeated: boolean;
  /**
   * Synthetic types used to override base event types
   * When set, corresponding eventIdents must be added.
   * An example of synthetic types is defined events which overlap with existing event types.
   */
  syntheticTypes: JourneyMap.SyntheticType[];
}

export namespace JourneyMap {
  export enum SyntheticType {
    SYNTHETIC_TYPE_INVALID = 0,
    SYNTHETIC_TYPE_DEFINED_EVENT = 1
  }
}

/**
 * Journey map constraint options.
 * Ordering is implied and thus isn't an option.
 */
export interface JourneyMapConstraints {
  /** Whether or not the journey should be produced for events in same session or across sessions. */
  inSameSession: boolean;
  /**
   * When supplied, will restrict the events available for journey mapping to the corresponding time range.
   * When complete_sessions is set, time_range restricts using SessionStart rather than EventStart.
   * If all time is desired, an explicit time range should be supplied with an empty start and end time.
   */
  timeRange: TimeRange | null;
  /**
   * Whether or not to restrict the journey map behaviors to those that are from completed sessions.
   * Additionally, modifies time_range constraint to restrict using SessionStart rather than EventStart.
   */
  completeSessions: boolean;
}

/**
 * EventIdent allows for configuring identity functions on a per event type basis.
 * Any non configured event types will receive no further identity past their event type.
 */
export interface EventIdent {
  pageView: PageViewIdent | null;
  custom: CustomIdent | null;
  click: ElementIdent | null;
  change: ElementIdent | null;
  seen: ElementIdent | null;
  definedEvent: DefinedEventIdent | null;
}

/** EventIdentValues contains the produced values from an event ident configuration. */
export interface EventIdentValues {
  /** The type value of the event. */
  type: string;
  /**
   * Ordered values in the context of the identity configuration.
   * The values list will always be the expected length, but the length is variable based on which "if_value" identity
   * clauses are matched.
   */
  values: EventIdentValue[];
}

export interface EventIdentValue {
  stringValue?: string;
  longValue?: protobuf.int64;
}

export namespace EventIdentValue {
  export enum value {
    stringValue = 1,
    longValue = 2
  }

  export function value_oneof(m: EventIdentValue): { opt: value.longValue, val: protobuf.int64 } | { opt: value.stringValue, val: string } | null {
    if (m.stringValue != null) { return { opt: value.stringValue, val: m.stringValue } }
    if (m.longValue != null) { return { opt: value.longValue, val: m.longValue } }
    return null;
  }
}

export interface PageViewIdent {
  builtInField?: PageViewIdent.PageViewField;
  /** "page_" prefix is implied and should be omitted */
  pageField?: string;
  next: PageViewIdentByValue[];
}

export namespace PageViewIdent {
  export enum PageViewField {
    FIELD_INVALID = 0,
    FIELD_PAGE_DEF_ID = 1
  }

  export enum field {
    builtInField = 1,
    /** "page_" prefix is implied and should be omitted */
    pageField = 2
  }

  export function field_oneof(m: PageViewIdent): { opt: field.builtInField, val: PageViewIdent.PageViewField } | { opt: field.pageField, val: string } | null {
    if (m.builtInField != null) { return { opt: field.builtInField, val: m.builtInField } }
    if (m.pageField != null) { return { opt: field.pageField, val: m.pageField } }
    return null;
  }
}

export interface PageViewIdentByValue {
  next: PageViewIdent | null;
  /** if set, next is only applied if the previous value matches the if_value clause */
  ifValue: EventIdentValue | null;
}

export interface CustomIdent {
  builtInField?: CustomIdent.CustomField;
  /** "evt_" prefix is implied and should be omitted */
  eventField?: string;
  next: CustomIdentByValue[];
}

export namespace CustomIdent {
  export enum CustomField {
    FIELD_INVALID = 0,
    FIELD_EVENT_NAME = 1
  }

  export enum field {
    builtInField = 1,
    /** "evt_" prefix is implied and should be omitted */
    eventField = 2
  }

  export function field_oneof(m: CustomIdent): { opt: field.builtInField, val: CustomIdent.CustomField } | { opt: field.eventField, val: string } | null {
    if (m.builtInField != null) { return { opt: field.builtInField, val: m.builtInField } }
    if (m.eventField != null) { return { opt: field.eventField, val: m.eventField } }
    return null;
  }
}

export interface CustomIdentByValue {
  next: CustomIdent | null;
  /** if set, next is only applied if the previous value matches the if_value clause */
  ifValue: EventIdentValue | null;
}

export interface ElementIdent {
  builtInField?: ElementIdent.ElementField;
  /** "elem_" prefix is implied and should be omitted */
  elemField?: string;
  next: ElementIdentByValue[];
}

export namespace ElementIdent {
  export enum ElementField {
    FIELD_INVALID = 0,
    FIELD_CSS = 1,
    FIELD_TEXT = 2,
    FIELD_NAMED_ELEMENT = 3
  }

  export enum field {
    builtInField = 1,
    /** "elem_" prefix is implied and should be omitted */
    elemField = 2
  }

  export function field_oneof(m: ElementIdent): { opt: field.builtInField, val: ElementIdent.ElementField } | { opt: field.elemField, val: string } | null {
    if (m.builtInField != null) { return { opt: field.builtInField, val: m.builtInField } }
    if (m.elemField != null) { return { opt: field.elemField, val: m.elemField } }
    return null;
  }
}

export interface ElementIdentByValue {
  next: ElementIdent | null;
  /** if set, next is only applied if the previous value matches the if_value clause */
  ifValue: EventIdentValue | null;
}

export interface DefinedEventIdent {
  builtInField?: DefinedEventIdent.DefinedEventField;
}

export namespace DefinedEventIdent {
  export enum DefinedEventField {
    FIELD_INVALID = 0,
    FIELD_DEFINED_EVENT_ID = 1
  }

  export enum field {
    builtInField = 1
  }

  export function field_oneof(m: DefinedEventIdent): { opt: field.builtInField, val: DefinedEventIdent.DefinedEventField } | null {
    if (m.builtInField != null) { return { opt: field.builtInField, val: m.builtInField } }
    return null;
  }
}
